import React, { useState } from "react";
import Header from "../components/Header";
import ab from "../ab.png";
import ac from "../ac.png";
import ad from "../ad.png";
import ae from "../ae.png";
import af from "../af.png";
import ah from "../ah.png";
import sabri from "../sabri.png";
import { FiArrowUpRight } from "react-icons/fi";

export default function Work() {
  const [cat, setCat] = useState(0);
  return (
    <div className="container">
      <Header />
      <h3 className="text-white mt-5">Work</h3>
      <div className="d-flex align-items-center mt-5">
        <p
          onClick={() => setCat(0)}
          className={`text-white pe-5 ${cat === 0 ? "border-bottom" : "none"}`}
        >
          React Application
        </p>
        <p
          onClick={() => setCat(1)}
          className={`text-white ms-4 pe-5 ${
            cat === 1 ? "border-bottom" : "none"
          }`}
        >
          UI-UX
        </p>
      </div>
      {cat === 0 && (
        <div className="my-1 d-flex flex-column">
          <a
            href="https://sneakr.netlify.app/"
            target="_blank"
            rel="noreferrer"
            className="my-3"
          >
            <FiArrowUpRight size={20} className="me-2" />
            Super Kick : E-Commerce App
          </a>

          <div>
            <a
              href="https://aijobster.work/"
              target="_blank"
              rel="noreferrer"
              className="my-3"
            >
              <FiArrowUpRight size={20} className="me-2" />
              Ai Jobster : Jobs Search App
            </a>
          </div>
        </div>
      )}
      {cat === 1 && (
        <div className="d-flex flex-wrap">
          <div className="web">
            <img src={ad} alt="card" />
          </div>
          <div className="web">
            <img src={ab} alt="card" />
          </div>
          <div className="web">
            <img src={ac} alt="card" />
          </div>
          <div className="web">
            <img src={af} alt="card" />
          </div>
          <div className="web">
            <img src={ah} alt="card" />
          </div>
          <div className="web">
            <img src={sabri} alt="card" />
          </div>
          <div className="web">
            <img src={ae} alt="card" />
          </div>
        </div>
      )}
    </div>
  );
}
